/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const GetStartedPage = withLazyComponent(
  lazy(() => import('./GetStartedPage'))
);

export const AgentSignupV2Page = withLazyComponent(
  lazy(() => import('./AgentSignupV2Page'))
);
